import './list-visor-controls.scss';

import ListVisorControlsComp from './ListVisorControls';

export default ListVisorControlsComp;
